import { useAuth } from "@/auth/AuthContext";
import { ADMIN_ROLE } from "@/lib/adminNav";
import { Navigate, Outlet } from "react-router-dom";

export function AdminLayout() {
  const { user } = useAuth();
  // The API answers 403 for everyone else; this just keeps them off empty pages.
  if (user?.role !== ADMIN_ROLE) return <Navigate to="/" replace />;

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <Outlet />
    </div>
  );
}
